// components
import Image from 'next/image';

// utilities
import { getImagePath } from '@/utils/images';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const ImageBlock = ({ image, maxWidth, maxHeight }) => {
  if (!image) {
    return null;
  }

  return (
    <VisibleLoading>
      {({ ref, className }) => (
        <Image
          ref={ref}
          src={getImagePath(image)}
          width={image.width}
          height={image.height}
          alt={image.alternativeText}
          className={`mx-auto min-w-[200px] rounded-3xl ${className || ''}`.trim()}
          style={
            maxWidth || maxHeight
              ? {
                  maxWidth: maxWidth ? `min(${maxWidth}, 90vw)` : '100%',
                  height: 'auto',
                  maxHeight: maxHeight || 'none'
                }
              : undefined
          }
        />
      )}
    </VisibleLoading>
  );
};
export default ImageBlock;
